import type { SVGProps } from 'react';

export type PenIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const PenIcon = ({ size = 14, ...rest }: PenIconProps) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" aria-hidden {...rest}>
    <title>edit</title>
    <path
      d="M8.2 1.6 L10.4 3.8 L4 10.2 L1.6 10.6 L2 8.2 Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);
